var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDrizzle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-drizzle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-drizzle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0372626,15.7499265 C20.7769052,15.7499265 23,13.5274194 23,10.7871891 C23,8.04637124 20.7769052,5.82386409 18.0372626,5.82386409 C17.6517616,5.82386409 17.2774261,5.87205171 16.9171942,5.95549857 C16.2267009,3.66717419 14.1040949,2 11.5912867,2 C8.51785667,2 6.02737933,4.49106499 6.02737933,7.56449502 C6.02737933,7.67791223 6.03678179,7.78897882 6.04383364,7.90122072 C5.7088709,7.81072201 5.35804151,7.75783316 4.99545904,7.75783316 C2.78823089,7.75783316 1,9.54723936 1,11.7538799 C1,13.9605203 2.78823089,15.7499265 4.99545904,15.7499265 L18.0372626,15.7499265 Z M9.4550574,18.7048163 C8.75311435,19.2612909 8.94799591,20.40749 9.62546331,20.9912111 C10.3047779,21.5744704 11.4671402,21.5961752 11.9118581,20.8198816 C12.4549403,19.8731821 13.3268275,16.6913481 13.3268275,16.6913481 C13.3268275,16.6913481 10.3107814,18.0273489 9.4550574,18.7048163",
    fill: "#44484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDrizzle);
export default __webpack_public_path__ + "static/media/ico-drizzle.d4460a9bddece1fe98734e54f4323681.svg";
export { ForwardRef as ReactComponent };